import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { selectCurrentUser } from "@/redux/authentication/selectors";
import {
  clearAnalyticsUser,
  setAnalyticsUser,
  trackPageview,
} from "@/libraries/analytics";

const AnalyticsTracker = (): null => {
  const location = useLocation();
  const currentUser = useSelector(selectCurrentUser);
  const lastUserIdRef = useRef<number | string | null>(null);

  useEffect(() => {
    const userId = currentUser?.id ?? null;
    if (userId === lastUserIdRef.current) return;

    if (userId) {
      setAnalyticsUser(userId);
    } else {
      clearAnalyticsUser();
    }
    lastUserIdRef.current = userId;
  }, [currentUser]);

  useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsTracker;
